module.exports = __webpack_public_path__ + "img/visualizing-the-blockchain.77a2b1e5.png";